import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _endsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/ends-with";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CheckBoxField, InputField } from '@unite-us/ui';
import CommunicationTypesCheckBoxes from '../../PhoneNumbers/EditPhoneNumbers/CommunicationTypesCheckBoxes';
import { RemoveEmailButton, RemoveEmailConfirmation } from './components';
import './stylesheets/inlineEmail.scss';
import { Field, useForm } from 'react-final-form';
import { isEmail, isRequired } from '../../../utils/validations';
import { map, noop } from 'lodash';
import { composeValidators } from '../../../utils/composeValidators';
function ProfileEmailFields(props) {
  var id = props.id,
    styles = props.styles,
    fieldName = props.fieldName;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showRemove = _useState2[0],
    setShowRemove = _useState2[1];
  var form = useForm();
  var onPrimaryChanged = function onPrimaryChanged(params) {
    var _context;
    var emails = _filterInstanceProperty(_context = form.getRegisteredFields()).call(_context, function (rf) {
      return _endsWithInstanceProperty(rf).call(rf, "is_primary");
    });
    emails.forEach(function (p) {
      if (!_includesInstanceProperty(p).call(p, params.input.name)) form.change(p, false);
    });
  };
  var onCancelRemove = function onCancelRemove() {
    setShowRemove(false);
  };
  var showRemoveConfirmation = function showRemoveConfirmation() {
    setShowRemove(true);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "inline-email-address"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 inline-email-address__email-address"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "".concat(fieldName, ".email_address"),
    validate: composeValidators(isRequired, isEmail, function (value, allValues, meta) {
      var message = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Email already exists on this profile';
      var emails = allValues.emails;
      var emailAddresses = map(emails, function (e) {
        return e.email_address;
      });
      var hasDuplicateEmail = _filterInstanceProperty(emailAddresses).call(emailAddresses, function (e) {
        return e === value;
      }).length > 1;
      return hasDuplicateEmail ? message : null;
    })
  }, function (params) {
    return /*#__PURE__*/React.createElement(InputField, _extends({
      autoFocus: true,
      id: "".concat(fieldName, ".email_address"),
      inline: false,
      label: "Email"
    }, params));
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4 inline-email-address__is-primary"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "".concat(fieldName, ".is_primary"),
    type: "checkbox"
  }, function (params) {
    return /*#__PURE__*/React.createElement(CheckBoxField, _extends({
      className: "check-box-field",
      id: "".concat(fieldName, ".is_primary"),
      label: "Primary",
      onChange: function onChange() {
        return onPrimaryChanged(params);
      }
    }, params));
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }, /*#__PURE__*/React.createElement("div", {
    style: showRemove ? styles.fadeRemove : styles.showRemove
  }, /* @todo we may want to add an explicit prop to show/hide this button */
  props.onRemove && /*#__PURE__*/React.createElement(RemoveEmailButton, {
    onClick: showRemoveConfirmation
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-10"
  }, /*#__PURE__*/React.createElement(CommunicationTypesCheckBoxes, {
    id: id,
    email: true,
    fieldName: "".concat(fieldName, ".acceptable_communication_types"),
    hideOralTypes: true
  }))), /*#__PURE__*/React.createElement(RemoveEmailConfirmation, {
    show: showRemove,
    onCancel: onCancelRemove,
    onConfirm: props.onRemove
  }));
}
ProfileEmailFields.propTypes = {
  id: PropTypes.string.isRequired,
  onPrimaryChange: PropTypes.func,
  onRemove: PropTypes.func,
  styles: PropTypes.object.isRequired
};
ProfileEmailFields.defaultProps = {
  onRemove: noop,
  styles: {
    fadeRemove: {
      opacity: '.3'
    },
    showRemove: {
      visibility: 'visible'
    },
    hideRemove: {
      visibility: 'hidden',
      display: 'none'
    },
    checkbox: {
      marginTop: '26px'
    }
  }
};
export default ProfileEmailFields;
//# sourceMappingURL=index.js.map